// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__9Q40-","visible":"Overlay_visible__B6wx2"};